/************************** button "add to cart" collection pages **************************/

function _addMeToCart(e, el) {
e = e || window.event;
e.preventDefault();

let formData = {
'items': [
{
'id': el.dataset.variant_id,
'quantity': 1
}
]
};

fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then((resp) => {
return resp.json();
})
.then((data) => {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));
})
.catch((err) => {
console.error('Error: ' + err);
})
}